import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DetailedTimesheet from "./Timesheet/DetailedTimesheet";
import { useJobProvider } from "../../../Providers/Consultant/Jobs";
import { useTimesheetProvider } from "../../../Providers/Consultant/Timesheet";
import CustomTable from "../../../Components/Table";
import { useNavigate } from "react-router-dom";

const headCells = [
  { disablePadding: false, label: "Job" },
  { disablePadding: false, label: "Job Description" },
  { disablePadding: false, label: "Client" },
  { disablePadding: false, label: "Status" },
  { disablePadding: false, label: "" },
];

export default function Timesheet({ detailedTimesheet, setDetailedTimesheet }) {
  const { jobs, fetchJobsForConsultant } = useJobProvider();
  const { setSelectedJobDetails, setSelectedTimesheet } = useTimesheetProvider();
  useEffect(() => {
    fetchJobsForConsultant();
  }, []);
  const navigate = useNavigate()

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover tabIndex={-1} key={row?.job.id}>
        <TableCell align="left">{row?.job.name}</TableCell>
        <TableCell className="truncate max-w-[250px]" align="left">{row?.job.description}</TableCell>
        <TableCell align="left">
          {`${row?.vendor?.company}`.trim()}
        </TableCell>
        <TableCell align="left">{row?.job.status}</TableCell>
        <TableCell
          align="left"
          className="cursor-pointer"
          onClick={() => {
            // setDetailedTimesheet(true);
            // setSelectedTimesheet(null);
            // setSelectedJobDetails({
            //   job: row?.job,
            //   vendor: row.vendor,
            // });
            navigate(`/dashboard/timesheets/${row?.job?.id}`)
          }}
        >
          <span className="text-sm text-blue-500">View Timesheets</span>
        </TableCell>
      </TableRow>
    );
  };

  return detailedTimesheet ? (
    <DetailedTimesheet setDetailedTimesheet={setDetailedTimesheet} />
  ) : (
    <CustomTable headCells={headCells} rows={jobs} CustomRow={CustomRow} />
  );
}
